/**
 * Created by jv on 2019-09-09 (10:50).
 */
import InvestmentsView from "../components/game/components/investments-view";

const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import GameSessionController from "Sources/controllers/game-session-controller";
import GamePageController from "Sources/controllers/game-page-controller";
import GameSessionMessage from "Sources/models/game-session-message";

import WasteDepotView from "Sources/components/popup/waste-depot";
import ResourceSubstitutionView from "Sources/components/popup/resource-substitution";
import ResourceLessView from "Sources/components/popup/resource-less";
import RefurbishingView from "Sources/components/popup/refurbishing";
import RentalServiceView from "Sources/components/popup/rental-service";
import InsufficientResourcesView from "Sources/components/popup/insufficient-resources";
import ClosedLoopView from "Sources/components/popup/closed-loop";

const gameResourcesHtml = require("Views/partials/game/shared/resource-bar.html");
const gameFooterHtml = require("Views/partials/game/shared/footer.html");
const GameViews = require.context("Sources/components/game/views", false, /\.js$/);
const infoIcons = require.context("!raw-loader!Images/info", false, /\.svg$/);

// Styles
require("Styles/pages/game.scss");

$(function()
{
    Shared.init();
    SeriousGame.init();
});

let SeriousGame = {};

((SeriousGame) =>
{
    let gamePageController;
    let gameSessionController;

    let joinSessionView;
    let introductionView;
    let questionnaireView;
    // let rankingView;
    let sellView;
    let businessModelView;
    let reconnectView;

    let currentGameView;

    let gameSessionId = null;
    let teamName = null;

    let gameSession;
    let caseWrapper;
    let roundOverview;
    let endGameData;

    let pathSessionId = null;

    let canReconnect = false;
    let isWaitingToReconnect = false;
    let reconnectAttempts = 0;

    // Will be set to false when client gets 'shouldClose' param from server, otherwise true
    let shouldReconnect = true;

    SeriousGame.init = function()
    {
        // gametest
        let pathSection2 = utils.getPathSection(2);

        if (pathSection2 === "sessionid")
        {
            pathSessionId = utils.getPathSection(3);
        }

        let websocketProtocol = window.location.protocol.includes("https") ? "wss:" : "ws:";

        gameSessionController = new GameSessionController({
            baseUrl: `${websocketProtocol}//${window.location.host}/services/1.0/realtime/gamesession/`
        });

        gameSessionController.addEventListener("session-opened", onSessionOpened);
        gameSessionController.addEventListener("session-closed", onSessionClosed);
        gameSessionController.addEventListener("session-error", onSessionError);
        gameSessionController.addEventListener("session-message", onSessionMessage);

        setUpHtmlPages();
        setUpViews();
        setGamePageController();

        setUpEventListeners();
    };

    function setUpHtmlPages()
    {
        let $gameResourcesHtmlCopy = $(gameResourcesHtml);
        let $gameFooterHtmlCopy = $(gameFooterHtml);

        $("#game-view-resource-bar").append($gameResourcesHtmlCopy);
        $("#game-view-footer").append($gameFooterHtmlCopy);

        LanguageManager.applyLocale($gameResourcesHtmlCopy);
        LanguageManager.applyLocale($gameFooterHtmlCopy);
    }

    function setUpViews()
    {
        introductionView = createGameView("introduction");
        questionnaireView = createGameView("questionnaire");
        // rankingView = createGameView("ranking");
        sellView = createGameView("sell");
        joinSessionView = createGameView("session-join", { sessionId: pathSessionId });
        businessModelView = createGameView("business-model");
        reconnectView = createGameView("reconnect");

        joinSessionView.onJoinSession = function(element)
        {
            gameSessionId = this.getFormSessionId();
            teamName = this.getFormTeamName();

            if (utils.isNotNull(teamName))
            {
                teamName = teamName.trim();
            }

            joinSession(gameSessionId, teamName);
        };

        introductionView.onTeamNameRegistered = function(teamName)
        {
            log.info("Team name selected: ", teamName);
            joinSessionView.setFormTeamName(teamName);
        }

        introductionView.onIntroductionCompleted = function(skipped)
        {
            log.info("Introduction complete (skipped? %s)", skipped);
            handleIntroductionEndRegistered();
        };

        questionnaireView.onSubmitQuestionnaire = function(questionnaireAnswers)
        {
            log.info("Submitting questionnaire", questionnaireAnswers);
            let message = GameSessionMessage.createRequest("submitQuestionnaire", null, questionnaireAnswers);
            gameSessionController.sendMessage(message);

            gamePageController.changePage(introductionView);
        };

        sellView.onSellProducts = function(info)
        {
            let message = GameSessionMessage.createRequest("sellProducts", null, info);
            gameSessionController.sendMessage(message);
        };

        businessModelView.onRenderCompleted = function()
        {

        };

        businessModelView.onInvestmentAdded = function(investment)
        {
            log.info("Sending purchase request to server for investment [%s]", investment.type);

            let data = {
                investmentKey: investment.key
            };

            let message = GameSessionMessage.createRequest("businessModelInvestment", null, data);
            gameSessionController.sendMessage(message);
        };

        businessModelView.onAssignEmployee = function(factory)
        {
            log.info("Sending assign employee request to server for factory [%s]", factory);

            let data = {
                factoryName: factory.name,
                ignoreResource: factory.ignoreResource,
                extraResource: factory.extraResource
            };

            let message = GameSessionMessage.createRequest("businessModelFactoryWorker", null, data);
            gameSessionController.sendMessage(message);
        }

        businessModelView.onInactiveSpotClick = function()
        {
            let container = $("<div>");
            let v = new InsufficientResourcesView({ container: container, type: "microchip" });
            v.render();
            Shared.Dialog.showMessageDialog({
                title: "",
                message: container,
                disposable: false,
                extraModalContentClass: "resource-less-background-container",
                onConfirm: () =>
                {
                }
            });
        }

        businessModelView.onAssignMineEmployee = function()
        {
            log.info("Sending assign employee to microchip factory request to server");

            let message = GameSessionMessage.createRequest("assignMineEmployee", null, null);
            gameSessionController.sendMessage(message);
        }

        businessModelView.onAssignMicrochipEmployee = function(ignoreResource, extraResource)
        {
            log.info("Sending assign employee to microchip factory request to server");

            if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "microchip_efficiency" }))
            {
                let container = $("<div>");

                let resourceView = new ResourceLessView({
                    container: container,
                    type: "microchip",
                    roundData: Object.assign({}, this.roundOverview.currentRoundData)
                });

                resourceView.render();

                Shared.Dialog.showMessageDialog({
                    title: "",
                    message: container,
                    disposable: false,
                    extraModalContentClass: "resource-less-background-container",
                    onConfirm: () =>
                    {
                        let resources = resourceView.getRemovedResource();

                        let data = {
                            ignoreResource: resources
                        };

                        let message = GameSessionMessage.createRequest("assignMicrochipEmployee", null, data);
                        gameSessionController.sendMessage(message);
                    }
                });
            }
            else if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "microchip_substitution" }))
            {
                let container = $("<div>");

                let resourceView = new ResourceSubstitutionView({
                    container: container, type: "microchip",
                    roundData: Object.assign({}, this.roundOverview.currentRoundData)
                });

                resourceView.render();

                Shared.Dialog.showMessageDialog({
                    title: "",
                    message: container,
                    disposable: false,
                    extraModalContentClass: "resource-substitution-background-container",
                    onConfirm: () =>
                    {
                        let data = {};

                        let resources = resourceView.getReplacedResource();
                        if (resources)
                        {
                            data.ignoreResource = resources.oldResource;
                            data.extraResource = resources.newResource;
                        }

                        let message = GameSessionMessage.createRequest("assignMicrochipEmployee", null, data);
                        gameSessionController.sendMessage(message);
                    }
                });
            }
            else
            {
                let data = {};
                let message = GameSessionMessage.createRequest("assignMicrochipEmployee", null, data);
                gameSessionController.sendMessage(message);
            }
        }

        businessModelView.onAssignSecondaryEmployee = function(ignoreResource, extraResource)
        {
            log.info("Sending assign employee to secondary factory request to server");

            if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_efficiency" }) || InvestmentsView.hasPurchasedInvestment(this.team, { title: "bike_efficiency" }))
            {
                let container = $("<div>");
                console.log("Create a new resource less view");

                let type = InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_factory" }) ? "phone" : "bike";
                let resourceView = new ResourceLessView({
                    container: container,
                    type: type,
                    roundData: Object.assign({}, this.roundOverview.currentRoundData)
                });

                resourceView.render();

                Shared.Dialog.showMessageDialog({
                    title: "",
                    message: container,
                    disposable: false,
                    extraModalContentClass: "resource-less-background-container",
                    onConfirm: () =>
                    {
                        let resources = resourceView.getRemovedResource();

                        let data = {
                            ignoreResource: resources
                        };

                        let message = GameSessionMessage.createRequest("assignSecondaryEmployee", null, data);
                        gameSessionController.sendMessage(message);
                    }
                });
            }
            else if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_substitution" }) || InvestmentsView.hasPurchasedInvestment(this.team, { title: "bike_substitution" }))
            {
                let container = $("<div>");

                let type = InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_factory" }) ? "phone" : "bike";
                let resourceView = new ResourceSubstitutionView({
                    container: container, type: type,
                    roundData: Object.assign({}, this.roundOverview.currentRoundData)
                });

                resourceView.render();

                Shared.Dialog.showMessageDialog({
                    title: "",
                    message: container,
                    disposable: false,
                    extraModalContentClass: "resource-substitution-background-container",
                    onConfirm: () =>
                    {
                        let data = {};

                        let resources = resourceView.getReplacedResource();
                        if (resources)
                        {
                            data.ignoreResource = resources.oldResource;
                            data.extraResource = resources.newResource;
                        }

                        let message = GameSessionMessage.createRequest("assignSecondaryEmployee", null, data);
                        gameSessionController.sendMessage(message);
                    }
                });
            }
            else
            {
                let data = {};
                let message = GameSessionMessage.createRequest("assignSecondaryEmployee", null, data);
                gameSessionController.sendMessage(message);
            }
        }

        businessModelView.onAssignWasteRecycleEmployee = function()
        {
            log.info("Sending assign employee to secondary factory request to server");

            let container = $("<div>");

            let wasteDepot = new WasteDepotView({ container: container });

            wasteDepot.render();

            Shared.Dialog.showMessageDialog({
                title: "",
                message: container,
                disposable: false,
                dialogId: "waste-depot-dialog",
                extraModalContentClass: "waste-depot-background-container",
                onConfirm: () =>
                {
                    let resources = wasteDepot.getChosenResources();

                    let data = {
                        resources
                    };

                    let message = GameSessionMessage.createRequest("assignWasteRecycleEmployee", null, data);
                    gameSessionController.sendMessage(message);
                }
            });
        }

        businessModelView.onAssignReuseEmployee = function()
        {
            log.info("Sending assign employee to secondary factory request to server");

            let container = $("<div>");

            let refurbishingView = new RefurbishingView({
                container: container,
                team: this.team,
                market: undefined,
                roundData: Object.assign({}, this.roundOverview.currentRoundData)
            });

            refurbishingView.render();

            Shared.Dialog.showMessageDialog({
                title: "",
                message: container,
                disposable: false,
                extraModalContentClass: "refurbishing-background-container",
                onConfirm: () =>
                {
                    let resource = refurbishingView.getChosenResource();

                    let data = {
                        resource
                    };

                    let message = GameSessionMessage.createRequest("assignReuseEmployee", null, data);
                    gameSessionController.sendMessage(message);
                }
            });
        }

        businessModelView.onAssignRentalEmployee = function()
        {
            log.info("Sending assign employee to secondary factory request to server");

            let container = $("<div>");

            let resourceType = "";
            let productCount = 0;
            if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_factory" }))
            {
                resourceType = "phone";
                productCount = this.roundOverview.currentRoundData.resourcePhone;
            }
            else if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "bike_factory" }))
            {
                resourceType = "bike";
                productCount = this.roundOverview.currentRoundData.resourceBike;
            }

            let rentalView = new RentalServiceView({
                container: container,
                resourceType: resourceType,
                productCount: productCount,
                resourceCount: this.roundOverview.currentRoundData.resourceRed,
                rental: JSON.parse(this.roundOverview.currentRoundData.rental),
                canAddResources: InvestmentsView.hasPurchasedInvestment(this.team, { title: "repair_workshop" })
            });

            rentalView.render();

            Shared.Dialog.showMessageDialog({
                title: "",
                message: container,
                disposable: true,
                cancelText: "rentalservice.rentproducts.cancel",
                confirmText: "rentalservice.rentproducts",
                dialogId: "rental-service-modal-dialog",
                extraModalContentClass: "rental-service-background-container",
                onConfirm: () =>
                {
                    let rentalInfo = rentalView.getRentalInfo();

                    let data = {
                        addResource: rentalInfo.addResource,
                        amount: rentalInfo.amount
                    };

                    let message = GameSessionMessage.createRequest("assignRentalEmployee", null, data);
                    gameSessionController.sendMessage(message);
                }
            });
        }

        businessModelView.onNextPhaseRequested = function()
        {
            log.info("Send next phase request to server");

            let message = GameSessionMessage.createRequest("businessModelNextPhase", null, null);
            gameSessionController.sendMessage(message);
        }

        businessModelView.onTeamClosedRound = function()
        {
            log.info("Sending close round request to server");

            let message = GameSessionMessage.createRequest("businessModelRoundClosed", null, null);
            gameSessionController.sendMessage(message);
        };

        businessModelView.onTeamOverviewChanged = function(teamEndData)
        {
            log.info("Changing team endgame overview to [%s]", teamEndData.teamName);
        };

        businessModelView.onTeamOverviewClosed = function()
        {
            log.info("Closed team endgame overview, changing title");
        };

        reconnectView.onCancelReconnect = function()
        {
            joinSessionView.setJoinButtonLoading(false);
            joinSessionView.showForm();

            gamePageController.changePage(joinSessionView);
        };
    }

    function setGamePageController()
    {
        let gameViews = [];

        gameViews.push(introductionView);
        gameViews.push(questionnaireView);
        // gameViews.push(rankingView);
        gameViews.push(sellView);
        gameViews.push(joinSessionView);
        gameViews.push(businessModelView);
        gameViews.push(reconnectView);

        // gamePageController = new GamePageController({
        //     basePath: "/game",
        //     gameViews,
        //     defaultView: introductionView,
        //     initialPage: "/game/introduction",
        //     onBeforePageChange,
        //     onContentShow
        // });

        gamePageController = new GamePageController({
            basePath: "/play",
            gameViews,
            defaultView: questionnaireView,
            initialPage: "/play/session-join",
            onBeforePageChange,
            onContentShow
        });

        gamePageController.init();
    }

    function createGameView(key, options)
    {
        let fileKey = `./${key}.js`;
        if (GameViews.keys().includes(fileKey))
        {
            let GameViewClass = GameViews(fileKey);

            return new GameViewClass({
                key,
                container: "#game-view-wrapper",
                gameSessionController,
                ...options
            });
        }
        else
        {
            log.error("Couldn't find game view [%s]", key);
        }
    }

    function onBeforePageChange(gameView)
    {
        log.info("On before page change - game view: %o", gameView);

        // Boolean determines if page change is allowed or not
        return true;
    }

    function onContentShow(gameView)
    {
        log.info("On content show - game view: %o", gameView);

        if (utils.isNotNull(gameView))
        {
            currentGameView = gameView;

            if (gameView.key === joinSessionView.key)
            {

            }
            else if (gameView.key === introductionView.key)
            {

            }
            else if (gameView.key === questionnaireView.key)
            {

            }
            else if (gameView.key === sellView.key)
            {
                businessModelView.checkGuidedIntroduction("sell");
                sellView.update();
            }
            else if (gameView.key === businessModelView.key)
            {

            }
            else
            {

            }

            gameView.show();
        }
    }

    function joinSession(sessionId, teamName)
    {
        gameSessionController.sessionId = sessionId;
        gameSessionController.teamName = teamName;
        gameSessionController.init();
        gameSessionController.connect();
    }

    function onSessionOpened(e)
    {
        log.debug("Session opened - %o", e);

        canReconnect = true;
        shouldReconnect = true;

        joinSessionView.setJoinButtonLoading(false);
        joinSessionView.showLoadingState();
    }

    function onSessionClosed(e)
    {
        log.debug("Session closed - %o", e);

        if (shouldReconnect)
        {
            reconnect({ retryCount: 3 });
        }
        else
        {
            joinSessionView.setJoinButtonLoading(false);
            joinSessionView.showForm();
            gamePageController.changePage(joinSessionView);
        }
    }

    function onSessionError(e)
    {
        log.debug("Session error: %o", e);
        reconnect({ retryCount: 3 });
    }

    function onSessionMessage(e)
    {
        log.debug("Session message: %o", e);
        handleMessage(e);
    }

    function reconnect(options)
    {
        if (!shouldReconnect) return;
        if (utils.isNull(options)) options = {};

        if (utils.isNull(gameSessionController) || utils.isNull(gameSessionController.sessionId) || utils.isNull(gameSessionController.teamName))
        {
            gamePageController.changePage(joinSessionView);
            return;
        }

        let retryCount = options.retryCount;
        let timeBetweenAttempts = options.timeBetweenAttempts || 3 * 1000;
        shouldReconnect = false;

        if (canReconnect)
        {
            // Reconnect can only happen when you were connected before, meaning 'canReconnect' is only set to true once connected
            canReconnect = false;
            reconnectAttempts = 0;

            shouldReconnect = true;

            reconnectView.clearReconnectResult();
            gamePageController.changePage(reconnectView);
        }
        else if (!options.skipTimeout && !isWaitingToReconnect)
        {
            log.info("Waiting for %dms before attempting another reconnect", timeBetweenAttempts);

            isWaitingToReconnect = true;

            setTimeout(() =>
            {
                isWaitingToReconnect = false;
                reconnect({ retryCount, skipTimeout: true, force: true });
            }, timeBetweenAttempts);

            return;
        }

        // Prevents that more than 1 reconnect attempt is running at the same time (canReconnect is immediately set to 'false' and maximum 1 reconnect timeout can run at any given time)
        if (shouldReconnect || options.force)
        {
            reconnectAttempts++;

            log.info("Trying to reconnect to game session '%s' for team '%s'\nReconnect attempts: %d / %d", gameSessionId, teamName, reconnectAttempts, retryCount);

            if (utils.isNumber(retryCount) && reconnectAttempts <= retryCount)
            {
                gameSessionController.connect();
            }
            else
            {
                // Show message
                reconnectView.setReconnectFailed();

                setTimeout(() =>
                {
                    joinSessionView.setJoinButtonLoading(false);
                    joinSessionView.showForm();

                    gamePageController.changePage(joinSessionView);
                }, 3000);
            }
        }
    }

    function handleMessage(event)
    {
        if (utils.isNotNull(event) && utils.isNotNull(event.data))
        {
            let message = utils.parseJSON(event.data, true);

            log.info("Message data - %o", message);

            if (utils.isNotNull(message))
            {
                switch (message.type)
                {
                    case "request":
                        handleMessageRequest(message);
                        break;
                    case "response":
                        handleMessageResponse(message);
                        break;
                    case "error":
                        handleMessageError(message);
                        break;
                }
            }
        }
    }

    function handleMessageRequest(message)
    {
        if (utils.isNotNull(message))
        {
            log.info(`handleMessageRequest:${message.service}`);
            switch (message.service)
            {
                case "closeConnection":
                    handleCloseConnectionRequest(message);
                    break;

                case "gameSessionJoined":
                    // This session successfully joined the game session
                    handleSessionJoined(message);
                    break;
                case "teamJoined":
                    // A team (different from this team) joined the game session
                    handleTeamJoined(message);
                    break;
                case "teamRemoved":
                    // A team has been removed from the game session
                    handleTeamRemoved(message);
                    break;
                case "startGame":
                    // Teacher started the game session
                    handleSessionStarted(message);
                    break;
                case "startNextRound":
                    handleRoundStarted(message, true);
                    break;
                case "teamStartNextRound":
                    handleRoundStarted(message, false);
                    break;
                case "startNextPhase":
                    handlePhaseStarted(message);
                    break;
                // Message when another team has ended their round so we can update information
                case "teamEndedRound":
                case "teamEndedRoundByTeacher":
                    handleTeamEndedRound(message);
                    break;
                // Message when teacher has closed the round instead of the team itself
                case "teacherEndedRound":
                    handleTeacherEndedRound(message);
                    break;

                case "reloadedData":
                    handleReloadedData(message);
                    break;
                case "gameFinished":
                    handleGameFinished(message);
                    break;
            }
        }
    }

    function handleMessageResponse(message)
    {
        if (utils.isNotNull(message))
        {
            switch (message.service)
            {
                case "investmentRegistered":
                    handleInvestmentRegistered(message);
                    break;
                case "employeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    break;
                case "mineEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleMineEmployeeAssigned(message);
                    break;
                case "microchipEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleMicrochipEmployeeAssigned(message);
                    break;
                case "secondaryEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleSecondaryEmployeeAssigned(message);
                    break;
                case "wasteRecycleEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleWasteRecycleEmployeeAssigned(message);
                    break;
                case "reuseEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleReuseEmployeeAssigned(message);
                    break;
                case "rentalEmployeeAssigned":
                    handleGenericEmployeeAssigned(message);
                    handleRentalEmployeeAssigned(message);
                    break;
                case "roundEndRegistered":
                    handleRoundEndRegistered(message);
                    break;
            }
        }
    }

    function handleMessageError(message)
    {
        if (utils.isNotNull(message))
        {
            if (utils.isNotNull(message.params))
            {
                let messageKey = `errors.websocket.${message.error}.message`;
                let messageText = LanguageManager.getValueForKey(messageKey);

                let allowedErrors = [
                    "E88326",
                    "E88327",
                    "E88328",
                    "E88329",
                    "E88330",
                    "E88331",
                    "E88332",
                    "E88333",
                    "E88334",
                    "E88335",
                    "E88336",
                    "E88337",
                    "E88338",
                    "E88339",
                ];

                if (messageKey !== messageText)
                {
                    if (utils.isNotNull(currentGameView) && currentGameView.key === "session-join")
                    {
                        // Show error message in 'session-join' form
                        joinSessionView.handleError(message.error);
                        joinSessionView.setFormError(messageText);
                        joinSessionView.setJoinButtonLoading(false);
                        joinSessionView.showForm();
                    }
                    else
                    {

                    }
                }

                if (allowedErrors.includes(message.error))
                {
                    // Show error message in dialog
                    Shared.Dialog.showMessageDialog({
                        title: LanguageManager.getValueForKey("errors.websocket.title"),
                        message: messageText,
                        disposable: false
                    });
                }
                else if (message.params["shouldClose"] === "true")
                {
                    shouldReconnect = false;
                    gameSessionController.disconnect();
                }
                else
                {
                    reconnect({ retryCount: 3 });
                }
            }
        }
    }

    function goToCurrentView()
    {
        // gamePageController.changePage(questionnaireView);
        // return;

        if (gameSession.status === "created")
        {
            gamePageController.changePage(joinSessionView);
            joinSessionView.showLoadingState();
        }
        else if (gameSession.status === "playing")
        {
            if (utils.isNotNull(roundOverview.currentRoundData))
            {
                let wasAlreadyOnBusinessModel = currentGameView.key === businessModelView.key;

                if (!wasAlreadyOnBusinessModel)
                {
                    gamePageController.changePage(businessModelView);
                }

                if (utils.isNotNull(roundOverview.currentRoundData.closed))
                {
                    businessModelView.showRankingScreen({
                        currentTeam: gameSession.team,
                        roundOverview,
                        asOverlay: false,
                        keepVisible: true
                    });
                }
                else if (roundOverview.currentRoundData.phase === 2)
                {
                    gamePageController.changePage(sellView);
                }
                else
                {
                    if (wasAlreadyOnBusinessModel)
                    {
                        // Note: quickfix ... need to go back to business model view if we are on 'waiting room score screen', otherwise we are stuck and have to refresh
                        if (businessModelView.rankingScreen.isOpen() && businessModelView.$rankingScreenContainer.hasClass("bm__background-filled"))
                        {
                            businessModelView.showBusinessModel(true, true);
                        }
                    }
                    else
                    {
                        businessModelView.showBusinessModel(true, true);
                    }
                }
            }
            else
            {
                gamePageController.changePage(questionnaireView);
            }
        }
        else if (gameSession.status === "finished")
        {
            gamePageController.changePage(businessModelView);
            businessModelView.showEndGameView(endGameData);
        }
    }

    function extractInitialData(message)
    {
        caseWrapper = message.data.caseWrapper;
        gameSession = message.data.gameSession;
        endGameData = message.data.endGameData;

        extractRoundOverview(message.data.roundOverview);
    }

    function extractRoundOverview(data)
    {
        roundOverview = data;

        if (utils.isNotNull(data.currentRoundData))
        {
            $(".game-current-round").text(data.currentRoundData.roundIndex + 1);
        }

        extractCommonDataSelf(roundOverview.commonTeamData);
    }

    function extractCommonDataSelf(commonTeamData)
    {
        roundOverview.commonDataSelf = null;

        if (utils.isNotNull(commonTeamData))
        {
            for (let i = 0; i < commonTeamData.length; i++)
            {
                if (commonTeamData[i].teamName === gameSession.team.name)
                {
                    roundOverview.commonDataSelf = commonTeamData[i];
                    break;
                }
            }
        }
    }

    function extractResourceDifference(previous, current)
    {
        let result = Object.keys(current).filter(value => value.startsWith("resource")).reduce((previousValue, currentValue) =>
        {
            previousValue[currentValue] = current[currentValue] - previous[currentValue];
            return previousValue;
        }, {});

        Object.keys(result).forEach(key =>
        {
            if (result[key] === 0)
            {
                delete result[key];
            }
        });

        return result;
    }

    function reloadData(message, continueToView = true)
    {
        extractInitialData(message);

        businessModelView.caseWrapper = caseWrapper;
        businessModelView.gameSession = gameSession;
        businessModelView.team = gameSession.team;
        sellView.team = gameSession.team;
        sellView.currentRoundData = roundOverview.currentRoundData;
        businessModelView.setRoundOverview(roundOverview);

        console.log("Setting locale to : " + gameSession.locale);
        LanguageManager.changeLocale(gameSession.locale);

        if (continueToView)
        {
            // TODO validate data??
            goToCurrentView();
        }
    }

    function handleCloseConnectionRequest(message)
    {
        log.info("Server requested to close connection for game session [%s] and team [%s]", gameSessionId, teamName);
        shouldReconnect = false;
        gameSessionController.disconnect();
    }

    function handleSessionJoined(message)
    {
        log.info("Successfully joined game session [%s] with team name [%s]\nGameSession: %o\nCase: %o", gameSessionId, teamName, gameSession, caseWrapper);
        reloadData(message);
    }

    function handleTeamJoined(message)
    {
        let newTeam = message.data.teamName;

        log.info("Team [%s] joined game session (session count: %d)", newTeam, message.data.sessionCount);

        if (utils.isNull(gameSession.teamList)) gameSession.teamList = [];

        if (!gameSession.teamList.includes(newTeam))
        {
            gameSession.teamList.push(newTeam);
        }
    }

    function handleTeamRemoved(message)
    {
        let removedTeam = message.data.teamName;

        log.info("Team [%s] removed from game session", removedTeam);

        if (utils.isNotNull(gameSession.teamList) && gameSession.teamList.includes(removedTeam))
        {
            for (let i = 0; i < gameSession.teamList.length; i++)
            {
                if (gameSession.teamList[i] === removedTeam)
                {
                    gameSession.teamList.splice(i, 1);
                    break;
                }
            }

            if (utils.isNotNull(businessModelView))
            {
                businessModelView.updateTeamList(gameSession.teamList);
            }
        }
    }

    function handleSessionStarted(message)
    {
        log.info("Session started - going to businessModel");

        extractInitialData(message);

        gamePageController.changePage(questionnaireView);
    }

    function handleRoundStarted(message, byTeacher)
    {
        log.info((byTeacher ? "Teacher" : "Team") + " started the next round", message);

        // extractRoundOverview(message.data);
        // extractInitialData(message);
        reloadData(message, false);

        let currentRoundData = roundOverview.currentRoundData;

        if (gameSession.team.roundData.hasOwnProperty(currentRoundData.roundIndex))
        {
            $("#btn-next-phase").prop("disabled", false);

            gameSession.team.roundData[currentRoundData.roundIndex] = currentRoundData;

            if (currentGameView.key !== businessModelView.key)
            {
                gamePageController.changePage(businessModelView);
            }

            businessModelView.setRoundOverview(roundOverview);
            // businessModelView.showBusinessModel(true);
            // businessModelView.hideScoreScreen();
            businessModelView.hideRankingScreen();
            businessModelView.showInvestments();
            businessModelView.renderInvestmentsCarousel();
            businessModelView.renderInvestmentDialog();

            showStartRoundDialogs();
        }
        else
        {
            log.error("Unable to find round data for round [%d]", currentRoundData.roundIndex);
        }
    }

    function handlePhaseStarted(message)
    {
        extractRoundOverview(message.data);

        let currentRoundData = roundOverview.currentRoundData;

        $("#btn-next-phase").prop("disabled", false);

        if (gameSession.team.roundData.hasOwnProperty(currentRoundData.roundIndex))
        {
            gameSession.team.roundData[currentRoundData.roundIndex] = currentRoundData;

            if (currentRoundData.phase === 1)
            {
                gamePageController.changePage(businessModelView);
                businessModelView.renderBusinessModelCanvas();
                businessModelView.showBusinessModel(true);
            }
            else if (currentRoundData.phase === 2)
            {
                gamePageController.changePage(sellView);
            }

            businessModelView.setRoundOverview(roundOverview);
            businessModelView.showLoader(false);
        }
        else
        {
            log.error("Unable to find round data for round [%d]", currentRoundData.roundIndex);
        }
    }

    function showStartRoundDialogs()
    {
        let showEventDialog;

        if (utils.isNotNull(roundOverview.currentEvent))
        {
            showEventDialog = () =>
            {
                businessModelView.pulsateEventButton();
                businessModelView.showEventDialog(true, false);
            };
        }

        if (utils.isNotNull(showEventDialog))
        {
            showEventDialog();
        }

        let data = roundOverview.currentRoundData;

        if (utils.isNotNull(data))
        {
            let index = data.roundIndex;

            if (index >= 0)
            {
                showStartRoundMessage(index);
            }
        }
    }

    function showStartRoundMessage(index)
    {
        let title = "start.round." + (index + 1) + ".title";
        let description = "start.round." + (index + 1) + ".description";

        if (index === 4)
        {
            let container = $("<div>");
            container.append(`<label data-localize="${description}"></label>`);
            container.append($("<div style='display: flex'>").append(infoIcons("./img_circulareconomy.svg")));
            LanguageManager.applyLocale(container);

            Shared.Dialog.showMessageDialog({
                title: title,
                message: container,
                disposable: false
            });
        }
        else
        {
            Shared.Dialog.showMessageDialog({
                title: title,
                message: description,
                disposable: false
            });
        }
    }

    function handleIntroductionEndRegistered()
    {
        introductionView.setLoadingState(false);

        // gamePageController.changePage(questionnaireView);
        gamePageController.changePage(businessModelView);
    }

    function handleInvestmentRegistered(message)
    {
        log.info("Investment purchase registered successfully");

        gameSession.team.investmentData = message.data.investmentData;
        extractRoundOverview(message.data.roundOverview);

        gameSession.team.roundData[roundOverview.currentRoundData.roundIndex] = roundOverview.currentRoundData;

        // if (currentGameView.key !== businessModelView.key) {
        //   gamePageController.changePage(businessModelView);
        // }

        businessModelView.gameSession = gameSession;
        businessModelView.team = gameSession.team;
        sellView.team = gameSession.team;
        sellView.currentRoundData = roundOverview.currentRoundData;
        businessModelView.setRoundOverview(roundOverview);
        businessModelView.hideInvestmentDialog();
        businessModelView.renderInvestmentsCarousel();
        businessModelView.renderInvestmentDialog();
        // Also hides investment dialog ( + set btn loading to false) and investment slider
        // businessModelView.showBusinessModel(true, true);

        businessModelView.checkGuidedIntroductionFeedback("investment-made");

        if (message.data["closed_loop_type"] && message.data["closed_loop_points"])
        {
            handleInvestmentClosedLoop(message.data["closed_loop_type"], message.data["closed_loop_points"]);
        }
    }

    function handleInvestmentClosedLoop(type, points)
    {
        let container = $("<div>");
        let popup = new ClosedLoopView({ container: container, type: type, points: points });
        popup.render();

        Shared.Dialog.showMessageDialog({
            message: container,
            disposable: false,
            extraModalContentClass: "closed-loop-background-container"
        });
    }

    function handleGenericEmployeeAssigned(message)
    {
        log.info("Assigned employee successfully");

        let resourcesDiff = extractResourceDifference(roundOverview.currentRoundData, message.data.roundOverview.currentRoundData);
        console.log(resourcesDiff);

        gameSession.team.factoryRoundData = message.data.factoryRoundData;
        extractRoundOverview(message.data.roundOverview);

        gameSession.team.roundData[roundOverview.currentRoundData.roundIndex] = roundOverview.currentRoundData;

        businessModelView.gameSession = gameSession;
        businessModelView.team = gameSession.team;
        sellView.team = gameSession.team;
        sellView.currentRoundData = roundOverview.currentRoundData;
        businessModelView.setRoundOverview(roundOverview);
        businessModelView.renderBusinessModelCanvas();

        businessModelView.checkGuidedIntroductionFeedback("assigned-employee");

        // todo: define the type based on the message
        // let info = { type: "info-factory" };
        //
        // businessModelView.showInfoScreen(info, "feedback", message);
    }

    function handleMineEmployeeAssigned(message)
    {
        businessModelView.showInfoScreen({ type: "info-mine" }, "feedback", message);
    }

    function handleMicrochipEmployeeAssigned(message)
    {
        businessModelView.showInfoScreen({ type: "info-factory" }, "feedback", message);
    }

    function handleSecondaryEmployeeAssigned(message)
    {
        businessModelView.showInfoScreen({ type: "info-factory" }, "feedback", message);
    }

    function handleWasteRecycleEmployeeAssigned(message)
    {
    }

    function handleReuseEmployeeAssigned(message)
    {
    }

    function handleRentalEmployeeAssigned(message)
    {
    }

    function handleRoundEndRegistered(message)
    {
        log.info("Round end registered successfully");

        // $("#btn-next-phase").prop("disabled", false);

        // extractRoundOverview(message.data);
        // extractInitialData(message);
        reloadData(message, false);

        businessModelView.setRoundOverview(roundOverview);
        // gamePageController.changePage(businessModelView);
        // businessModelView.showScoreScreen({asOverlay: false});

        // change this if more events are needed
        if (roundOverview.currentRoundData.roundIndex !== 3 && roundOverview.currentRoundData.roundIndex !== 7)
        {
            log.info("Send next round request to server");

            let request = GameSessionMessage.createRequest("startNextRound", null, null);
            gameSessionController.sendMessage(request);
        }
        else
        {
            gamePageController.changePage(businessModelView);
            businessModelView.showBusinessModel(false);
            businessModelView.showRankingScreen({
                currentTeam: gameSession.team,
                roundOverview,
                asOverlay: false,
                keepVisible: true
            });
        }
    }

    function handleTeamEndedRound(message)
    {
        console.info("Team [%s] ended its current round", message.data.teamName);

        roundOverview.commonTeamData = message.data.commonTeamData;
        extractCommonDataSelf(roundOverview.commonTeamData);

        if (currentGameView.key === businessModelView.key)
        {
            businessModelView.setRoundOverview(roundOverview);
            businessModelView.renderBusinessModelCanvas();
        }
    }

    function handleTeacherEndedRound(message)
    {
        // Same as when team would end the round, but instead it's the teacher who forced the team to close the round
        log.info("Round end registered successfully");

        extractRoundOverview(message.data);

        businessModelView.setRoundOverview(roundOverview);
        businessModelView.showRankingScreen({
            asOverlay: false
        });
    }

    function handleReloadedData(message)
    {
        log.info("Data has been reloaded for game session [%s]\nGameSession: %o\nCase: %o", gameSessionId, gameSession, caseWrapper);
        reloadData(message);
    }

    function handleGameFinished(message)
    {
        log.info("All teams have closed the last round - game is finished");
        endGameData = message.data;
        businessModelView.showEndGameView(endGameData);
    }

    function setUpEventListeners()
    {
    }

})(SeriousGame);



// WEBPACK FOOTER //
// ./app/js/entries/game.js